import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-box-com',
  templateUrl: './confirmation-box.com.html'
})

export class ConfirmationBoxComponent {

  @Input() data = null;
  @Input() msg = '确定删除？';
  @Output() event = new EventEmitter<any>();

  public confirm() {
    this.event.emit({ source: 'confirmation-box', data: this.data, action: 'confirm' });
  }

  public cancel() {
    this.event.emit({ source: 'confirmation-box', data: null, action: 'cancel' });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/confirmation-box/confirmation-box.com.ts